var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-timeline',_vm._l((_vm.activities),function(activity,index){return _c('el-timeline-item',{key:index,attrs:{"color":"#2b73af","timestamp":_vm._f("formatTimer")(activity.createTime)}},[_vm._v(" "+_vm._s(activity.unitName)+"("+_vm._s(activity.userName)+") 执行了【"+_vm._s(activity.operation)+"】 ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }